import { Component, OnInit, inject } from '@angular/core';
import { ModuleSectionsService } from 'src/app/core/services/module-sections/module-sections.service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-player-layout',
  templateUrl: './player-layout.component.html',
  styleUrls: ['./player-layout.component.scss'],
  standalone: true,
  imports: [RouterOutlet],
})
export class PlayerLayoutComponent implements OnInit {
  moduleSections = inject(ModuleSectionsService);


  ngOnInit() {}
}
